import React, { FunctionComponent } from 'react'
import styles from './StatisticsPage.module.sass'
import StatisticsFilters from './StatisticsFilters/StatisticsFilters'
import ColoredTabs from '../../navigation/ColoredTabs/ColoredTabs'
import { ROUTES } from '../../../http/routes'
import { Redirect, Route, Switch } from 'react-router'
import { Colors } from '../../../styles'
import ManagerTab from './ManagerTab'
import UserTab from './UserTab'
import ObjectTab from './ObjectTab'
import ProjectTab from './ProjectTab'
import { useRootDispatch } from '../../../utils/hooks'
import { push } from 'connected-react-router'
import StatisticsCapture from './StatisticsCapture/StatisticsCapture'
import StatisticsInfo from './StatisticsInfo/StatisticsInfo'
import TaskTab from './TaskTab'

interface TabItem {
    text: string,
    path: string,
}

const tabs: TabItem[] = [{
    text: 'Менеджер',
    path: ROUTES.STATISTICS_MANAGER,
}, {
    text: 'Исполнитель',
    path: ROUTES.STATISTICS_USER,
}, {
    text: 'Исполнитель - Объект',
    path: ROUTES.STATISTICS_USER_OBJECT,
},{
    text: 'Проект',
    path: ROUTES.STATISTICS_PROJECT,
},{
    text: 'Задачи',
    path: ROUTES.STATISTICS_TASK,
}]

const getText = (item: TabItem): string => item.text

const StatisticsPage: FunctionComponent = () => {
    const dispatch = useRootDispatch()
    const active = tabs.find(item => item.path === window.location.pathname) ?? tabs[0]

    return <div className={styles.statistics}>
        <StatisticsFilters/>
        <StatisticsCapture/>
        <StatisticsInfo/>
        <ColoredTabs
            className={styles.tabs}
            items={tabs}
            toKey={getText}
            render={getText}
            active={active}
            onClick={item => dispatch(push(item.path))}
            toColor={() => Colors.blue}
        />
        <div className={styles.content}>
            <Switch>
                <Route path={ROUTES.STATISTICS_MANAGER} component={ManagerTab}/>
                <Route path={ROUTES.STATISTICS_USER} component={UserTab}/>
                <Route path={ROUTES.STATISTICS_USER_OBJECT} component={ObjectTab}/>
                <Route path={ROUTES.STATISTICS_PROJECT} component={ProjectTab}/>
                <Route path={ROUTES.STATISTICS_TASK} component={TaskTab}/>
                <Route render={() => <Redirect to={ROUTES.STATISTICS_MANAGER}/>}/>
            </Switch>
        </div>
    </div>
}

export default StatisticsPage